module.exports = __webpack_public_path__ + "img/fastly.13a509cd.svg";